import { gql } from "@apollo/client";

export const GET_ORDERS = gql`
	query GetOrders {
		myOrders {
			nodes {
				id
				orderNumber
				createdAt
				status
				cancelledAt
				shippingAddress {
					firstName
					lastName
					zipCode
					addressLine1
					addressLine2
					state {
						name
					}
					country {
						name
					}
				}
				totalPrice
				orderItems {
					nodes {
						quantity
						variant {
							name
							product {
								name
								imageSrc
							}
						}
					}
				}
			}
		}
	}
`;

export const CANCEL_ORDER = gql`
	mutation CancelOrder($id: UUID!, $reason: String!) {
		cancelOrder(input: { pOrderId: $id, cancelReason: $reason }) {
			clientMutationId
		}
	}
`;
